export enum PortalAppMode {
	NOMINAL = 'nominal',
	MAINTENANCE = 'maintenance',
	OUTAGE = 'outage',
	NOT_IMPLEMENTED = 'not-implemented'
}